import {
  Alert,
  AppBar,
  Box,
  Button,
  Container,
  Grid,
  Hidden,
  Paper,
  Snackbar,
  Tab,
  Tabs,
  Toolbar,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { PropTypes } from "prop-types";
import React, { useState, useEffect, useContext } from "react";
import SwipeableViews from "react-swipeable-views";
import { LeaderDashboardService } from "../../services/leaderDashboard.Service";
import GroupCombineResults from "./GroupCombineResults";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../common/RouteConstants";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import UnitFilterDrawer from "../../sharedComponents/UnitFilterDrawer";
import { AppDataContext } from "../../common/appContext";
import { isShowUnitDrawerItem } from "../../configs/AppSettings";

const useStyles = makeStyles((theme) => ({
  bgBlue: {
    height: "131vh",
    background:
      "-webkit-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
  },
  appbarBackground: {
    backgroundColor: "#fff",
    color: "#1d428a",
  },
  backButton: {
    backgroundColor: "white",
    minWidth: "50px",
    "&:hover": {
      backgroundColor: "white",
    },
    textTransform: "none",
    border: "1px solid lightgrey",
    boxShadow: "1px 1px 3px 1px lightgrey",
  },
  actionButtons: {
    padding: "0px 12px 0px 10px",
    height: "40px",
  },
  appbar: {
    backgroundColor: "#f5f5f5",
    color: "#000000",
    "& .Mui-selected": {
      color: theme.palette.primary.main,
    },
  },
  pageHeaderContainer: {
    display: "flex",

    // Apply column direction for screen sizes less than 400px
    [theme.breakpoints.down(400)]: {
      flexDirection: "column",
    },
  },
  pageHeaderTitle: {
    flexGrow: 1,
    fontWeight: "450",
    paddingRight: "20px",
    fontSize: "1.1rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem !important",
    },
  },
  notesContainer: {
    display: "flex",
    alignItems: "center",
  },
  notesHeaderText: {
    marginBottom: theme.spacing(0.5),
    color: "#1d428a",
    fontSize: "16px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px !important",
    },
  },
  notesHeaderTextIcon: {
    color: "#1d428a",
    paddingRight: "5px",
    fontSize: "20px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "10px !important",
    },
    [theme.breakpoints.down(450)]: {
      marginTop: "0px",
    },
  },
}));

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function CombineResults() {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedMiniTab, setSelectedMiniTab] = useState(0);
  const theme = useTheme();
  const navigate = useNavigate();
  const {
    lengthUnits,
    weightUnits,
    setWeightUnits,
    setLengthUnits,
    selectedEventId,
    user,
  } = useContext(AppDataContext);

  //#Alert data holders.
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState("warning");
  const [alertMessage, setAlertMessage] = useState("");

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
    // if (newValue === 1) {
    //   navigate(RouteConstants.PLAYER_LIST);
    // }
  };
  const [notes, setNotes] = useState([]);

  const handleChangeIndex = (index) => {
    setSelectedTab(index);
  };

  useEffect(() => {
    LeaderDashboardService.getLeaderBoardNotes().then((response) => {
      //Filter the notes based on event.
      const filteredData = response.data.filter(
        (notes) => notes.childID === parseInt(selectedEventId)
      );

      //Make all unique notes and set to respective state.
      setNotes([
        ...new Map(filteredData.map((m) => [m.childName, m])).values(),
      ]);
    });
  }, [selectedEventId]);

  function getSpecifiedNotes(iStationID) {
    switch (iStationID) {
      case 1:
        return notes.find(
          (x) =>
            x.childName.replace(/\s/g, "").toLowerCase() ===
            "StrengthAndAgility".toLowerCase()
        );
      case 2:
        return notes.find(
          (x) =>
            x.childName.replace(/\s/g, "").toLowerCase() ===
            "Shooting".toLowerCase()
        );
      default:
        return notes.find(
          (x) =>
            x.childName.replace(/\s/g, "").toLowerCase() ===
            "Anthropometrics".toLowerCase()
        );
    }
  }

  function getNotesBody(iStationID) {
    const notesDetails = getSpecifiedNotes(iStationID);

    return (
      notesDetails?.isActive && (
        <Box className={classes.notesContainer}>
          <InfoOutlinedIcon className={classes.notesHeaderTextIcon} />
          <Typography variant="subtitle1" className={classes.notesHeaderText}>
            {notesDetails.description}
          </Typography>
        </Box>
      )
    );
  }

  return (
    <>
      <AppBar
        position="sticky"
        className={classes.appbarBackground}
        sx={{ zIndex: "1098" }}
      >
        <Toolbar sx={{ px: "8px" }}>
          <Box className={classes.pageHeaderContainer}>
            <Typography noWrap variant="h6" className={classes.pageHeaderTitle}>
              Combine Results
            </Typography>

            {getNotesBody(selectedMiniTab)}
          </Box>
        </Toolbar>
      </AppBar>
      <Container
        maxWidth={false}
        sx={{
          padding: { xs: "0px", sm: "0px", md: "16px", lg: "16px" },
          backgroundColor: "#ffff",
        }}
      >
        <Grid container pt={2} pb={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container>
              <Grid item lg xs={12}>
                <GroupCombineResults setSelectedMiniTab={setSelectedMiniTab} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {isShowUnitDrawerItem && (
          <UnitFilterDrawer
            lengthUnits={lengthUnits}
            weightUnits={weightUnits}
            setLengthUnits={setLengthUnits}
            setWeightUnits={setWeightUnits}
          />
        )}

        {/* Common Snack bar for all tabs */}
        <Snackbar
          open={alert}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={3000}
          onClose={() => setAlert(false)}
        >
          <Alert
            onClose={() => setAlert(false)}
            severity={alertType}
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Container>
    </>
  );
}
